export { default } from './FlashyTabBar';
export { default as FlashyTabBarItem } from './item';
export {
  FlashyTabBarConfig,
  FlashyTabBarItemConfig,
  FlashyTabBarItemProps,
  FlashyTabBarIconProps,
} from './types';
